<template>
  <div>
    <Header />
    <b-container id="body-container" fluid>
      <b-row class="justify-content-center">
        <b-col cols="10">


           <b-row align-h="start" align-v="center" class="header-text-container">
            <b-col cols="8" md="4">
              <span>
                <h4 class="text-blackish title-body">Messaging Policy</h4>
              </span>
            </b-col>
            <b-col cols="4" md="3">
              <div class="color-design"></div>
            </b-col>
          </b-row>

          <b-row align-h="start" class="header-text-container">

            <b-col md="12">
                <div>
                  </div>
                  <div>
                      <div>

                            <p>Thanks for choosing Gravity!  Please carefully read this messaging policy as it forms a part of the legal agreement between you and Gravity.  If you have any questions about this messaging policy, please contact us at <a href='mailto:compliance@launchgravity.com'>compliance@launchgravity.com.</a></p>

                            <p>At Gravity, our mission is to help our customers thrive, learn, and connect with email.  In order to accomplish this, we need to keep our Gravity service running smoothly, without disruption, and with high delivery rates.  To this end, Gravity’s Messaging Policy provides guidance as to how the Service should be used, and more importantly, what constitutes misuse of the Service, either because the activity violates applicable law or because it poses a risk to you, us, or to other customers.  All undefined capitalized terms used in this Messaging Policy have the meaning set forth in the Terms of Use.</p>

                            <p>CUSTOMER AGREES TO USE THE SERVICE IN COMPLIANCE WITH THIS MESSAGING POLICY.  IF CUSTOMER IS NOT IN COMPLIANCE WITH THIS MESSAGING POLICY, Gravity MAY, IN ITS SOLE DISCRETION, TAKE ANY ACTION IT DEEMS APPROPRIATE REGARDING CUSTOMER’S ACCESS TO THE SERVICE, INCLUDING WITHOUT LIMITATION, IMMEDIATE SUSPENSION OR TERMINATION OF CUSTOMER’S ACCOUNT WITHOUT NOTICE.</p>

                            <p><span className='text-primary'>Email Sending Guidelines.</span>  Customer will follow these guidelines when sending emails using the Service:</p>

                            <ol>
                                <li>
                                    <p> Use only permission-based marketing email lists (i.e., lists in which each recipient has granted permission to receive email from Customer by affirmatively opting-in).</p>
                                </li>

                                <li>
                                    <p> Always include a working “unsubscribe” mechanism in each marketing email that allows the recipient to opt out from Customer marketing mailing list (transactional messages that are exempt from “unsubscribe” requirements of applicable law are exempt from this requirement).</p>
                                </li>
                                <li>
                                    <p> Comply with all requests from recipients to be removed from Customer mailing list within ten (10) days of receipt of the request or the appropriate deadline under applicable law.</p>
                                </li>
                                <li>
                                    <p>Maintain, publish, and comply with a privacy policy that meets all applicable legal requirements and include in each email a link to the privacy policy applicable to that email.</p>
                                </li>
                                <li>
                                    <p>Include a valid physical mailing address applicable to the email or a link to that information.</p>
                                </li>
                                <li>
                                    <p>Do not disguise the origin, or subject matter of, any email or falsify or manipulate the originating message address, subject line, header, or transmission path information for any email.</p>
                                </li>
                                <li>
                                    <p>Do not send to: (a) email addresses obtained from purchased or rented email lists; (b) email addresses programmatically generated or scraped from the Internet; or (c) role-based or non-specific addresses (e.g., webmaster@domain.com or info@domain.com) on a routine basis.</p>
                                </li>
                                <li>
                                    <p>Do not send emails that result in an unacceptable number of spam or similar complaints (even if the email themselves are not actually spam) or employ sending practices that negatively impact the Service or other customers of the Service.</p>
                                </li>
                                <li>
                                    <p>Do not use the Service to send unsolicited bulk email or otherwise considered junk email.  Some examples of such emails include affiliate marketing, lead generation, penny stocks, credit repair, illegal gambling, multi-level marketing, pyramid schemes, prostitution, direct to consumer pharmaceutical sales, payday loans, and chain letters.</p>
                                </li>
                            </ol>
                            <p><span className='text-primary'>Restricted Content</span>.  Customer will not submit to the Service or use the Service to collect, store, or process: (a) social security numbers, passport numbers, military numbers, voter numbers, driver’s license numbers, taxpayer numbers, or other government identification numbers; (b) Protected Health Information (as defined by HIPPA), or similar information under other comparable laws or regulations; (c) financial account numbers (including without limitation, credit or debit card numbers, primary account numbers, bank account numbers, related security codes or passwords, or similar information; or (d) “special classes of data” (as defined by GDPR) of EU residents, or similar information under other comparable laws or regulations.</p>

                            <p><span className='text-primary'>Anti-harassment</span>.  Customer will not use the Service to: (a) store, distribute or transmit any malware or other material that Customer know, or have reasonable grounds to believe, is or may be tortious, libelous, offensive, infringing, harassing, harmful, disruptive or abusive; or (b) promote, commit, aid, or abet any behavior, which Customer know, or have reasonable grounds to believe, is or may be tortious, libelous, offensive, infringing, harassing, harmful, disruptive or abusive.  Some examples of the foregoing may include emails that promote racism, homophobia, or other hate speech.</p>

                            <p><span className='text-primary'>Compliance with Law</span>.  Customer’s use of the Services must comply with all applicable laws, rules, regulations, ordinances, and court orders of any kind of any jurisdiction applicable to Customer, Gravity, and to any Recipient.  It is Customer’s responsibility to be aware of and understand all applicable laws and ensure that Customer and its Users of the Account comply at all times with applicable law. Some examples of applicable laws include US CAN-SPAM Act, Canada Anti-Spam Law (CASL), EU General Data Protection Regulation (GDPR), member state implementations of the EU ePrivacy Directive, AU Federal Privacy Act and its Australian Privacy Principles, and other laws relating to data protection, privacy, intellectual property, security, terrorism, corruption, child protection, and import/export laws.</p>

                            <p><span className='text-primary'>Modification</span>.  Gravity may modify this Messaging Policy prospectively at any time by posting the revised version on the Website and/or sending Customer a copy of the modified policy through other reasonable means.  Customer’s continued use of the Service will be considered acceptance of any such modification. All modifications to this Messaging Policy will be effective immediately upon posting, unless otherwise noted.</p>

                            <p>V2.9 April 1, 2020</p>

                      </div>
                  </div>

            </b-col>
          </b-row>

        </b-col>
      </b-row>

    </b-container>
    <Footer />
  </div>
</template>


<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/screens/home/header.sass
</style>


<script>
// sub components
import Header from './header.vue'
import Footer from '@/components/footer.vue'
//import startFreeTrial from '@/components/startFreeTrial'

export default {
  name: 'home',
  components: {
    Header,
    Footer,
  },
}
</script>
